
import { PropType, defineComponent } from 'vue'
import Button from '@/components/elements/Button.vue'
import {
  EventDetailHospitalContent,
  EventDetailHospitalMovie
} from '@/types/EventDetail'
export default defineComponent({
  name: 'EventDetailHospitalList',
  components: {
    Button
  },
  props: {
    hospitals: {
      type: Array as PropType<EventDetailHospitalContent[]>,
      default: () => [],
      required: true
    },
    isArchived: {
      type: Boolean,
      default: false,
      required: true
    },
    openModal: {
      type: Function as PropType<
        (movies: EventDetailHospitalMovie[], title: string) => void
      >,
      required: true
    }
  },
  setup(props) {
    const convertToTag = (offline: string): string =>
      offline ? 'div' : 'router-link'
    const convertToLink = (offline: string, id: string): string | null =>
      offline ? null : `/search/hospital/detail/${id}`
    const isArchivedHospitalMovie = (movie: EventDetailHospitalMovie[]) => {
      return (
        props.isArchived &&
        movie &&
        !!movie.filter((m) => m.label.includes('video')).length
      )
    }

    return {
      convertToTag,
      convertToLink,
      isArchivedHospitalMovie
    }
  }
})
